import {ReportFormat} from '../enums/ReportFormat';
import {RequestStatus} from '../enums/RequestStatus';

/**
 * @typedef {Object} ReduxObservableListExportsReducers
 * @property {ReduxObservableListExportsState} initialExportState
 * @property {Function} reducer
 */

/**
 * @typedef {FilterData} ReduxObservableListExportsState
 * @property {Boolean} isShowingModal
 * @property {ReportFormat} format
 * @property {RequestStatus} status
 // * @property {TimerExportState~TargetFilter} targetFilter TODO
 // * @property {TimerExportState~TargetData} targetData TODO
 * @property {?Error} err
 */

export function buildReportReducer(reactReduxModal, reduxRequest, actions, options) {
  const reactReduxModalReducer = reactReduxModal.reducers.reducer;
  const reduxRequestReducer = reduxRequest.reducers.reducer;

  /** @type {ReduxObservableListExportsState} */
  const initialState = Object.assign({
    format: ReportFormat.XLSX,
    ...reactReduxModal.reducers.initialState,
    ...reduxRequest.reducers.initialState,
  }, options.initialExportState || {});

  /**
   * @param {ReduxObservableListExportsState} state
   * @param {ReduxAction<any>} action
   * @return {ReduxObservableListExportsState}
   */
  function reducer(state = initialState, action) {
    switch (action.type) {
      case actions.applyFilter.TYPE:
        return {
          ...state,
          ...action.payload,
        };

      // Boilerplate:
      case actions.hideModal.TYPE:
        return initialState;
      default:
        // combine the reducers. They share the same state
        return reduxRequestReducer(reactReduxModalReducer(state, action), action);
    }
  }

  return {
    initialState,
    reducer,
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-observable-list-exports/reducers.js